import React from 'react';
import safetyLogo from '../images/logo_safety100_mice.svg';

export default function Loading() {
  return (
    <div className='w-screen h-[calc(100dvh)]'>
      <div className='flex justify-center items-center h-[calc(100%-55px)]'>
        <img src={safetyLogo} alt='logo' />
      </div>
      <p className='text-center tracking-[-0.6px] text-8 text-[#878787]'>COPYRIGHT © 2023 BY GSIL Co., Ltd. All rights reserved.</p>
    </div>
  );
}

